import { Component, OnInit, Inject } from '@angular/core'
import {
  Destroyable,
  Rental,
  ConfirmDialogService,
  TaxV3,
  updateRentalTaxes,
  updateRentalTaxesComplete,
  untilDestroy,
} from '@tokeet-frontend/tv3-platform'
import { Store } from '@ngrx/store'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Actions, ofType } from '@ngrx/effects'
import { finalize } from 'rxjs/operators'

@Component({
  selector: 'app-copy-taxes-from-dialog',
  templateUrl: './copy-taxes-from-dialog.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  host: {
    class: 'modal-content',
  },
})
export class CopyTaxesFromDialogComponent extends Destroyable implements OnInit {
  get rental() {
    return this.data.rental
  }
  isLoading = false
  selectedTaxes: TaxV3[] = []

  constructor(
    private store: Store<any>,
    private actions: Actions,
    private confirmDialog: ConfirmDialogService,
    public dialogRef: MatDialogRef<CopyTaxesFromDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { rental: Rental }
  ) {
    super()
  }

  ngOnInit(): void {
    this.actions.pipe(ofType(updateRentalTaxesComplete), untilDestroy(this)).subscribe(() => {
      this.dialogRef.close('done')
    })
  }

  onSelect(items: TaxV3[]) {
    this.selectedTaxes = items
  }

  onOverwrite() {
    this.isLoading = true
    this.confirmDialog
      .confirm({
        title: $localize`Overwrite current taxes?`,
        body: $localize`Copying taxes from different rental will overwrite current taxes.`,
      })
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(() => {
        this.store.dispatch(updateRentalTaxes({ taxes: this.selectedTaxes, rentalId: this.rental.id }))
      })
  }

  onAdd() {
    this.isLoading = true
    const taxes = [...(this.rental.taxes || []), ...this.selectedTaxes]
    this.store.dispatch(updateRentalTaxes({ taxes, rentalId: this.rental.id }))
  }

  close() {
    this.dialogRef.close()
  }
}
